import { createTheme, type MantineColorsTuple } from '@mantine/core';

// Risky Consulting — Teal #00A6B4
const riskyTeal: MantineColorsTuple = [
  '#D6FCFF', // 0 - lightest
  '#ACF8FF', // 1
  '#59F1FF', // 2
  '#00CADC', // 3
  '#00A6B4', // 4 - base
  '#008F9C', // 5
  '#007B86', // 6
  '#006670', // 7
  '#005259', // 8
  '#003D43', // 9 - darkest
];

// Digital Consulting — Yellow #FCDD33
const riskyYellow: MantineColorsTuple = [
  '#FFFBE5', // 0
  '#FEF7CC', // 1
  '#FDEE98', // 2
  '#FCE24B', // 3
  '#FCDD33', // 4 - base
  '#FBD70C', // 5
  '#DEBD03', // 6
  '#B99E03', // 7
  '#947E02', // 8
  '#6F5F02', // 9
];

// Social Consulting — Orange #F15A22
const riskyOrange: MantineColorsTuple = [
  '#FDEAE3', // 0
  '#FBD6C8', // 1
  '#F8AC91', // 2
  '#F36E3E', // 3
  '#F15A22', // 4 - base
  '#E3470E', // 5
  '#C23D0C', // 6
  '#A2330A', // 7
  '#812908', // 8
  '#611E06', // 9
];

// Business Consulting — Green #39B54A
const riskyGreen: MantineColorsTuple = [
  '#E5F7E8', // 0
  '#CCEFD0', // 1
  '#98DFA2', // 2
  '#4BC65C', // 3
  '#39B54A', // 4 - base
  '#329F41', // 5
  '#2B8938', // 6
  '#24722E', // 7
  '#1D5B25', // 8
  '#16441C', // 9
];

export const theme = createTheme({
  primaryColor: 'risky-teal',
  colors: {
    'risky-teal': riskyTeal,
    'risky-yellow': riskyYellow,
    'risky-orange': riskyOrange,
    'risky-green': riskyGreen,
  },
  defaultRadius: 'md',
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif',
  headings: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif',
  },
});

// Zone colour mapping — used by layout to set page accents
export type ColourZone = 'teal' | 'yellow' | 'orange' | 'green';

export const ZONE_COLOURS: Record<ColourZone, string> = {
  teal: 'risky-teal',
  yellow: 'risky-yellow',
  orange: 'risky-orange',
  green: 'risky-green',
};

// Route→zone mapping now lives on the nav registry in layout/NavItems.tsx —
// the header derives its stripe from findNavItem(), so routes can never fall
// out of step with the nav again.
